<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <page-title>Port Shipment History</page-title>
    <search
      :portSearchFunction="loadSearchResultForPortFromAPI"
      :clearSearch="params ? true : false"
      :clearSearchFunction="clearSearch"
    ></search>
    <div class="has-background-white has-padding-30">
      <h2
        class="is-size-5 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black has-margin-bottom-20"
      >Port History </h2>
      <main-table
        :shipping-requests="tableData"
        :currentPage="currentPage"
        :isBackendPaginated="true"
        :onPageChange="onPageChange"
        :total="total"
        canViewShippingRequest
      ></main-table>
    </div>
  </div>
</template>

<script>
import Search from "@/modules/commonModule/layouts/Search";
import MainTable from "../components/MainTable.vue";
import GetAllPortShippingRequest from "@/modules/portsModule/api/graphql/queries/GetAllPortShippingRequest.gql";
import { PORT_MUTATION_TYPES } from "@/store/mutation-types";
import SYSTEM_FLAGS from "@/modules/commonModule/helpers/getSystemFlags";
import { mapMutations, mapGetters } from "vuex";
import SearchAndFilterQueries from "@/modules/commonModule/api/graphql/queries/SearchAndFilterQueries";

export default {
  name: "port-history",
  components: { MainTable, Search },

  data() {
    return {
      currentPage: 1,
      total: 0,
      isLoading: false,
      params: null
    };
  },

  mounted() {
    this.loadAllPortShippingRequestsFromAPI(this.currentPage);
  },

  computed: {
    ...mapGetters({
      allPortShippingRequests: "getAllPortShippingRequests",
      searchQueryData: "getPortSearchShippingRequests"
    }),
    allPortRequests() {
      return this.allPortShippingRequests.filter(result => result.port_status);
    },
    tableData: function() {
      if (this.params) {
        return this.searchQueryData;
      } else {
        return this.allPortRequests;
      }
    }
  },

  methods: {
    ...mapMutations({
      saveAllPortShippingRequests:
        PORT_MUTATION_TYPES.SAVE_ALL_PORT_SHIPPING_REQUESTS,
      savePortSearchResults:
        PORT_MUTATION_TYPES.SAVE_PORT_SEARCH_AND_FILTER_REQUESTS
    }),
    /**
     * Load shipping requests with the port_status of docked
     */
    loadAllPortShippingRequestsFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetAllPortShippingRequest,
          variables: {
            port_of_discharge_id: this.$store.getters.getPortID,
            page: page
          }
        })
        .then(response => {
          const shippingRequests =
            response.data.getAllShippingRequestsForAPort.data;
          this.saveAllPortShippingRequests(shippingRequests);
          const {
            total,
            currentPage
          } = response.data.getAllShippingRequestsForAPort.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Shipping requests loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load shipping requests",
            type: "is-danger"
          });
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadAllPortShippingRequestsFromAPI(this.currentPage);
    },
    loadSearchResultForPortFromAPI: function(
      page,
      searchQuery,
      portID,
      startDate,
      endDate
    ) {
      this.isLoading = true;

      if (startDate || endDate) {
        this.params = {
          start_date: startDate,
          end_date: endDate,
          search_query: searchQuery,
          port_id: portID,
          page
        };
      } else {
        this.params = {
          search_query: searchQuery,
          port_id: portID,
          page
        };
      }

      this.$apollo
        .query({
          query: SearchAndFilterQueries.SearchAndFilterForPorts,
          variables: {
            ...this.params
          }
        })
        .then(response => {
          const shippingRequests =
            response.data.SearchAndFilterPortShippingRequests.data;
          this.savePortSearchResults(shippingRequests);

          const {
            total,
            currentPage
          } = response.data.SearchAndFilterPortShippingRequests.paginatorInfo;

          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "search results loaded",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load seach query please try again",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    clearSearch() {
      if (this.params) {
        this.params = null;
      }
    }
  }
};
</script>
